import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { RoleBasedRouteProps } from "./roleBasedRoute.types";
import { LoadingSpinner } from "@/components";

export const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({
  children,
  requiredRoles,
  redirectTo = "/collaborators/directory",
}) => {
  const { user, loading, userHasRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/auth/login" />;
  }

  // Check if user needs profile update (except for profile update pages)
  if (
    user.needsProfileUpdate &&
    !location.pathname.includes("/me/atualizar-cadastro")
  ) {
    return <Navigate to="/me/atualizar-cadastro" replace />;
  }

  // If no roles required, allow access to any logged-in user
  if (!requiredRoles || requiredRoles.length === 0) {
    return <>{children}</>;
  }

  // Check if user has any of the required roles
  const hasRequiredRole = requiredRoles.some((role) => userHasRole(role));

  if (!hasRequiredRole) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleBasedRoute;